/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimPaymentDetailPayloadDto } from './ClaimPaymentDetailPayloadDto';
import {
    ClaimPaymentDetailPayloadDtoFromJSON,
    ClaimPaymentDetailPayloadDtoFromJSONTyped,
    ClaimPaymentDetailPayloadDtoToJSON,
    ClaimPaymentDetailPayloadDtoToJSONTyped,
} from './ClaimPaymentDetailPayloadDto';

/**
 * 
 * @export
 * @interface CreateClaimPaymentPayloadDto
 */
export interface CreateClaimPaymentPayloadDto {
    /**
     * Claim ID
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    claimId: string;
    /**
     * Contract ID
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    contractId: string;
    /**
     * Transaction type
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    transactionType: CreateClaimPaymentPayloadDtoTransactionTypeEnum;
    /**
     * Transaction date
     * @type {Date}
     * @memberof CreateClaimPaymentPayloadDto
     */
    transactionDate: Date;
    /**
     * Paid date (entered by Claims once transaction is paid through bank)
     * @type {Date}
     * @memberof CreateClaimPaymentPayloadDto
     */
    paidDate?: Date;
    /**
     * Payment status
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    paymentStatus: CreateClaimPaymentPayloadDtoPaymentStatusEnum;
    /**
     * Payee / Account Name
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    payeeAccountName: string;
    /**
     * Country of the bank account
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    country: string;
    /**
     * Account number
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    accountNumber?: string;
    /**
     * Swift code
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    swiftCode?: string;
    /**
     * Receiving party currency (ISO currency code)
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    receivingPartyCurrency: string;
    /**
     * Settlement currency (ISO currency code)
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    settlementCurrency: string;
    /**
     * Settlement exchange rate (user input from bank)
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    settlementExchangeRate: string;
    /**
     * Claims payment source
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    claimsPaymentSource: CreateClaimPaymentPayloadDtoClaimsPaymentSourceEnum;
    /**
     * Premium bordereaux month (required if Claims Payment Source is Premium)
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    premiumBordereauxMonth?: string;
    /**
     * From bank account number
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    bankAccountNumber: string;
    /**
     * Comments to (Binder, Broker, Internal)
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    commentsTo?: string;
    /**
     * Comments (free text)
     * @type {string}
     * @memberof CreateClaimPaymentPayloadDto
     */
    comments?: string;
    /**
     * Claim binder details (payment/reserve breakdown by loss type)
     * @type {Array<ClaimPaymentDetailPayloadDto>}
     * @memberof CreateClaimPaymentPayloadDto
     */
    claimPaymentDetails: Array<ClaimPaymentDetailPayloadDto>;
}


/**
 * @export
 */
export const CreateClaimPaymentPayloadDtoTransactionTypeEnum = {
    Payment: 'Payment',
    ReserveChangeOnly: 'Reserve Change Only'
} as const;
export type CreateClaimPaymentPayloadDtoTransactionTypeEnum = typeof CreateClaimPaymentPayloadDtoTransactionTypeEnum[keyof typeof CreateClaimPaymentPayloadDtoTransactionTypeEnum];

/**
 * @export
 */
export const CreateClaimPaymentPayloadDtoPaymentStatusEnum = {
    AwaitingApproval: 'Awaiting Approval',
    Approved: 'Approved',
    NotApproved: 'Not Approved',
    Paid: 'Paid'
} as const;
export type CreateClaimPaymentPayloadDtoPaymentStatusEnum = typeof CreateClaimPaymentPayloadDtoPaymentStatusEnum[keyof typeof CreateClaimPaymentPayloadDtoPaymentStatusEnum];

/**
 * @export
 */
export const CreateClaimPaymentPayloadDtoClaimsPaymentSourceEnum = {
    Float: 'Float',
    Premium: 'Premium',
    CashCall: 'Cash Call'
} as const;
export type CreateClaimPaymentPayloadDtoClaimsPaymentSourceEnum = typeof CreateClaimPaymentPayloadDtoClaimsPaymentSourceEnum[keyof typeof CreateClaimPaymentPayloadDtoClaimsPaymentSourceEnum];


/**
 * Check if a given object implements the CreateClaimPaymentPayloadDto interface.
 */
export function instanceOfCreateClaimPaymentPayloadDto(value: object): value is CreateClaimPaymentPayloadDto {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('payeeAccountName' in value) || value['payeeAccountName'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('receivingPartyCurrency' in value) || value['receivingPartyCurrency'] === undefined) return false;
    if (!('settlementCurrency' in value) || value['settlementCurrency'] === undefined) return false;
    if (!('settlementExchangeRate' in value) || value['settlementExchangeRate'] === undefined) return false;
    if (!('claimsPaymentSource' in value) || value['claimsPaymentSource'] === undefined) return false;
    if (!('bankAccountNumber' in value) || value['bankAccountNumber'] === undefined) return false;
    if (!('claimPaymentDetails' in value) || value['claimPaymentDetails'] === undefined) return false;
    return true;
}

export function CreateClaimPaymentPayloadDtoFromJSON(json: any): CreateClaimPaymentPayloadDto {
    return CreateClaimPaymentPayloadDtoFromJSONTyped(json, false);
}

export function CreateClaimPaymentPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimPaymentPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'contractId': json['contractId'],
        'transactionType': json['transactionType'],
        'transactionDate': (new Date(json['transactionDate'])),
        'paidDate': json['paidDate'] == null ? undefined : (new Date(json['paidDate'])),
        'paymentStatus': json['paymentStatus'],
        'payeeAccountName': json['payeeAccountName'],
        'country': json['country'],
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
        'swiftCode': json['swiftCode'] == null ? undefined : json['swiftCode'],
        'receivingPartyCurrency': json['receivingPartyCurrency'],
        'settlementCurrency': json['settlementCurrency'],
        'settlementExchangeRate': json['settlementExchangeRate'],
        'claimsPaymentSource': json['claimsPaymentSource'],
        'premiumBordereauxMonth': json['premiumBordereauxMonth'] == null ? undefined : json['premiumBordereauxMonth'],
        'bankAccountNumber': json['bankAccountNumber'],
        'commentsTo': json['commentsTo'] == null ? undefined : json['commentsTo'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'claimPaymentDetails': ((json['claimPaymentDetails'] as Array<any>).map(ClaimPaymentDetailPayloadDtoFromJSON)),
    };
}

export function CreateClaimPaymentPayloadDtoToJSON(json: any): CreateClaimPaymentPayloadDto {
    return CreateClaimPaymentPayloadDtoToJSONTyped(json, false);
}

export function CreateClaimPaymentPayloadDtoToJSONTyped(value?: CreateClaimPaymentPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'contractId': value['contractId'],
        'transactionType': value['transactionType'],
        'transactionDate': ((value['transactionDate']).toISOString()),
        'paidDate': value['paidDate'] == null ? undefined : ((value['paidDate']).toISOString()),
        'paymentStatus': value['paymentStatus'],
        'payeeAccountName': value['payeeAccountName'],
        'country': value['country'],
        'accountNumber': value['accountNumber'],
        'swiftCode': value['swiftCode'],
        'receivingPartyCurrency': value['receivingPartyCurrency'],
        'settlementCurrency': value['settlementCurrency'],
        'settlementExchangeRate': value['settlementExchangeRate'],
        'claimsPaymentSource': value['claimsPaymentSource'],
        'premiumBordereauxMonth': value['premiumBordereauxMonth'],
        'bankAccountNumber': value['bankAccountNumber'],
        'commentsTo': value['commentsTo'],
        'comments': value['comments'],
        'claimPaymentDetails': ((value['claimPaymentDetails'] as Array<any>).map(ClaimPaymentDetailPayloadDtoToJSON)),
    };
}

